/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsCommonDeviceInfo } from './common.model';

export interface DeviceActionEvent {
	devices: AnalyticsCommonDeviceInfo[];
	event_sub_type: DeviceAction;
	location: DeviceActionLocation;
}

export interface DeviceActionCancelledEvent {
	devices: AnalyticsCommonDeviceInfo[];
	event_sub_type: CancelledDeviceAction;
	location: DeviceActionLocation;
}

export enum DeviceAction {
	NameChange = 'name_change',
	Reboot = 'reboot',
	Identify = 'identify',
	AddTag = 'add_tag',
	RemoveTag = 'remove_tag',
	RemoveDevice = 'remove_device'
}

export type CancelledDeviceAction = DeviceAction.Reboot | DeviceAction.RemoveDevice;

export enum DeviceActionLocation {
	PropertiesPanel = 'properties_panel',
	DevicesPage = 'devices_page'
}
